import styled, { CSSProperties } from "styled-components";

interface MiniHomeCardProps {
  backgroundImage: string;
}


export const MiniHomeCard = styled.div<MiniHomeCardProps>`
  position: relative;
  width: 100%;
  height: 174px;
  background-color: #06B0D7;
  background-image: url(${props => props.backgroundImage});
`;

export const MiniHomeCardImage = styled.img`
  position: absolute;
  top: 0;
  right: 20px;
  width: auto;
  height: 154px;  
`;

export const MiniHomeCardText = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 164px;
  display: flex;
  flex-direction: column; /* 세로 방향으로 배치 */
  justify-content: flex-end; /* 하단 정렬 */
`;

export const StyledDiv = styled.div`
  text-align: left; /* 텍스트를 왼쪽으로 정렬합니다. */
  margin-left: 20px; /* 왼쪽에 20px의 마진을 줍니다. */
  margin-bottom: 10px; /* 왼쪽에 20px의 마진을 줍니다. */
  /*color: white;  폰트 컬러를 화이트로 지정합니다. */
  font-weight: bold; /* 볼드 스타일을 적용합니다. */
  /* font-size: 22px;  폰트 크기를 16px로 설정합니다. */
`;

export const Column = styled.div`
 /* width: 35%;  컬럼의 너비는 50%로 설정합니다. */
  height: 25px;
  text-align: left; /* 텍스트를 왼쪽으로 정렬합니다. */
  margin-left: 20px; /* 왼쪽에 20px의 마진을 줍니다. */
  /*color: white;  폰트 컬러를 화이트로 지정합니다. */
  font-weight: bold; /* 볼드 스타일을 적용합니다. */
  font-size: 16px; /* 폰트 크기를 16px로 설정합니다. */
  display: flex;
  align-items: center;
  /* background-color: #06B0D7;*/
`;

// 2개의 컬럼을 감싸는 부모 컨테이너 스타일을 정의합니다.
export const Container = styled.div`
  display: flex; /* Flexbox를 사용하여 자식 요소를 가로로 배치합니다. */
`;

export const VerticalCard = styled.div`  
  width: 100%;
  margin-top: 10px;
`;